import { render, staticRenderFns } from "./shelfposition-edit.vue?vue&type=template&id=31d629fc&"
import script from "./shelfposition-edit.vue?vue&type=script&lang=ts&"
export * from "./shelfposition-edit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports